<template>
    <div class="account-view">
        <email-update-dialog v-model="showEmailChangeModal" :email="email" />
        <change-password-dialog v-model="showPasswordChangeModal" @password-changed="onPasswordChanged()" />

        <b-modal
            v-model="showNameWarnModal"
            title="Name Update"
            modal-class="vue-need-bootstrap"
            lazy
            centered
            no-close-on-backdrop
            @ok="updateUserName"
        >
            As you have an old password, updating the account name will force a password reset, you WILL have to reset
            your password through the email that will be sent to continue using your account.
        </b-modal>

        <div class="row content mt-4 mb-4">
            <div class="col-6 d-flex flex-wrap justify-content-center mb-3">
                <b-card title="Profile" class="white-card card-with-input">
                    <b-form @submit.stop.prevent="onProfileSubmit()">
                        <b-form-group id="username-input" label="Username" label-for="username-input">
                            <b-form-input id="username-input" v-model="user.Username" required readonly />
                        </b-form-group>

                        <b-form-group id="name-input" label="Name" label-for="name-input">
                            <b-form-input
                                id="name-input"
                                v-model="name"
                                placeholder="Account name"
                                required
                                trim
                                :disabled="savingName"
                            />
                        </b-form-group>

                        <loader-btn
                            class="float-right"
                            type="submit"
                            variant="primary"
                            :loading="savingName"
                            :disabled="!modifiedName"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>

            <div class="col-6 d-flex flex-wrap justify-content-center mb-3">
                <b-card title="Login" class="white-card card-with-input">
                    <b-form>
                        <b-form-group id="email-input" label="Email" label-for="email-input">
                            <b-form-input id="email-input" v-model="email" type="email" required readonly />
                            <b-form-text class="text-right link">
                                <a
                                    href="javascript:void(0)"
                                    :class="{ disabled: loadingEmail || email === null }"
                                    @click="showEmailChangeModal = true"
                                    >Change email</a
                                >
                            </b-form-text>
                        </b-form-group>

                        <b-form-group id="password-input" label="Password" label-for="password-input">
                            <b-form-input id="password-input" type="password" value="fakepassword" readonly required />
                            <b-form-text class="text-right link"
                                ><a href="javascript:void(0)" @click="showPasswordChangeModal = true"
                                    >Change password</a
                                >
                            </b-form-text>
                        </b-form-group>
                    </b-form>
                </b-card>
            </div>

            <div v-if="hasAffiliate" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="Paypal Account" class="white-card card-with-input">
                    <b-form @submit.stop.prevent="onPaypalSubmit()">
                        <b-form-group id="your-paypal-email" label="Email" label-for="your-paypal-email">
                            <b-form-input
                                id="referral-code-input"
                                v-model="paypalEmail"
                                type="email"
                                placeholder="mypaypal@customily.com"
                                required
                                style="cursor: text !important"
                            />
                            <b-form-text>
                                Please add the Paypal email where you'd like to receive payouts.
                            </b-form-text>
                        </b-form-group>

                        <loader-btn
                            class="float-right"
                            type="submit"
                            variant="primary"
                            :loading="savingPaypalEmail"
                            :disabled="!modifiedPaypalEmail"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>

            <div v-if="hasAffiliate" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <div class="card white-card card-with-input">
                    <div class="card-body">
                        <div class="card-title d-flex align-items-center">
                            <h4>Referrals</h4>
                            <b-icon
                                id="question-circle-icon"
                                v-tippy
                                :content="`Invite your friends to Customily and
                                get a discount for every friend! Learn more about how referrals work
                                <a href=${helpc} target='_blank'>here</a>`"
                                icon="question-circle"
                                class="h6"
                            />
                        </div>
                        <b-form-group
                            id="your-referral-code"
                            label="Share this url to get installs on Shopify"
                            label-for="your-referral-code"
                        >
                            <b-form-input
                                id="referral-code-input-1"
                                v-model="myStampUrl"
                                required
                                disabled
                                style="cursor: text !important"
                            />
                        </b-form-group>
                    </div>
                </div>
            </div>

            <div v-if="showReferralCard && !hasAffiliate" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <div class="card white-card card-with-input">
                    <div class="card-body">
                        <div class="card-title">
                            <h4>
                                Referrals
                                <b-icon
                                    v-tippy
                                    content="Share this URL and invite Shopify stores to install Customily to earn commissions!"
                                    icon="question-circle"
                                    class="h6"
                                />
                            </h4>
                        </div>
                        <form @submit.stop.prevent="onReferrerSubmit()">
                            <b-form-group
                                id="your-referral-code"
                                label="Share this url to get installs on Shopify"
                                label-for="your-referral-code"
                            >
                                <b-form-input
                                    id="referral-code-input-3"
                                    v-model="myReferralCode"
                                    required
                                    disabled
                                    style="cursor: text !important"
                                />
                                <b-form-text> {{ numberReferred }} friends used your referral code. </b-form-text>
                            </b-form-group>

                            <b-modal
                                v-model="showReferrerSuccess"
                                title="Success!"
                                modal-class="vue-need-bootstrap"
                                lazy
                                centered
                                no-close-on-backdrop
                                @ok="updateUserName"
                            >
                                You successfully used a referral code, both you and your friend will receive a discount
                            </b-modal>

                            <b-form-group
                                v-if="showReferrerInput"
                                id="referrer"
                                label="Enter your friend's code and get a discount"
                                label-for="referrer"
                            >
                                <b-form-input id="referrer" v-model="referrer" />
                            </b-form-group>
                            <b-form-text v-if="referrerEmail">
                                You've used <b>{{ referrerEmail }}</b> code
                            </b-form-text>

                            <div v-if="referrerErrorMessage" class="invalid-feedback d-block">
                                {{ referrerErrorMessage }}
                            </div>

                            <loader-btn
                                v-if="showReferrerInput"
                                class="float-right"
                                type="submit"
                                variant="primary"
                                :loading="savingReferrer"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="Security" class="white-card card-with-input" style="display: none">
                    <form @submit.stop.prevent="onSecuritySubmit()">
                        <div class="form-group">
                            <c-checkbox v-model="clipartProtection" label="Clipart protection" switch />
                            <small class="form-text text-muted">
                                Clipart protection will only be available for newly created image libraries elements
                            </small>
                        </div>

                        <loader-btn
                            class="float-right"
                            type="submit"
                            variant="primary"
                            :loading="savingSecurity"
                            :disabled="!modifiedSecurity"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Ref, computed, onBeforeMount, ref } from 'vue';
import { AxiosError } from 'axios';
import store from '@/store';
import { getReferrerData, logout, setReferrer, updateUser, updateUserAffiliate } from '@/api/user';
import { CustomilyUser } from '@/typings/user';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import EmailUpdateDialog from '@/components/EmailUpdateDialog/EmailUpdateDialog.vue';
import ChangePasswordDialog from '@/components/ChangePasswordDialog/ChangePasswordDialog.vue';

const helpc = 'https://help.customily.com/en/article/how-to-get-a-discount-by-inviting-your-friends';

const emit = defineEmits(['user-updated']);

const name: Ref<string | null> = ref(null);
const email: Ref<string | null> = ref(null);
const loadingEmail = ref(true);
const showEmailChangeModal = ref(false);
const showPasswordChangeModal = ref(false);
const showNameWarnModal = ref(false);
const savingName = ref(false);
const savingReferrer = ref(false);
const clipartProtection = ref(false);
const savingSecurity = ref(false);
const myReferralCode: Ref<string | null> = ref(null);
const showReferrerInput = ref(false);
const referrer = ref('');
const numberReferred = ref(0);
const showReferrerSuccess = ref(false);
const referrerEmail = ref('');
const referrerErrorMessage = ref('');
const showReferralCard = ref(false);
const savingPaypalEmail = ref(false);
const paypalEmail = ref('');
const myStampUrl = ref('');

const user = computed(() =>
    store.state.user?.ImpersonatedFromChildUser ? store.state.user?.UserImpersonatedFrom : store.state.user
);

const modifiedName = computed(() => name.value && user.value?.Name !== name.value);
const modifiedSecurity = computed(() => user.value?.SegmentLibraryImages !== clipartProtection.value);
const modifiedPaypalEmail = computed(() => user.value?.UserAffiliate?.PaypalEmail !== paypalEmail.value);

const hasAffiliate = computed(() => {
    if (user.value?.AccessRoles == null) return false;
    return user.value?.AccessRoles?.Serialized.includes('affiliate');
});

onBeforeMount(async () => {
    name.value = user.value!.Name;
    email.value = user.value!.Email;
    loadingEmail.value = false;
    clipartProtection.value = user.value!.SegmentLibraryImages;
    myReferralCode.value = user.value!.CodeForReferrals;
    referrer.value = '';
    referrerErrorMessage.value = '';
    paypalEmail.value = user.value!.UserAffiliate?.PaypalEmail || '';
    myStampUrl.value = user.value!.UserAffiliate?.StampUrl || '';

    const referrerData = await getReferrerData();
    showReferrerInput.value = user.value!.ReferredBy === null && referrerData.UserIsInTrial;
    numberReferred.value = referrerData.NumberReferred;
    referrerEmail.value = referrerData.ReferredEmail;
    showReferralCard.value = referrerData.IsShopify;
});

const onProfileSubmit = async () => {
    // For accounts that do not have a name (old account with a fixed pre-determined password) alert them that changing the name will
    //  force the to reset the password
    if (!user.value?.Name) {
        showNameWarnModal.value = true;
    } else {
        await updateUserName();
    }
};

const onSecuritySubmit = async () => {
    try {
        savingSecurity.value = true;
        const user = await updateUser(undefined, clipartProtection.value);
        updateUserState(user);
    } finally {
        savingSecurity.value = false;
    }
};

const updateUserName = async () => {
    try {
        // Save the new user name and update it in the store
        savingName.value = true;
        if (name.value) {
            const user = await updateUser(name.value);
            updateUserState(user);
        }
    } finally {
        savingName.value = false;
    }
};

const onReferrerSubmit = async () => {
    try {
        savingReferrer.value = true;
        const referrerEmail = await setReferrer(referrer.value);
        showReferrerInput.value = false;
        showReferrerSuccess.value = true;
        referrerEmail.value = referrerEmail;
        referrerErrorMessage.value = '';
    } catch (_error) {
        const error = _error as AxiosError;
        if ([400, 500].includes(error.response?.status || 0)) {
            referrerErrorMessage.value = error.response?.data.Message;
        }
    } finally {
        savingReferrer.value = false;
    }
};

const onPaypalSubmit = async () => {
    savingPaypalEmail.value = true;
    try {
        if (paypalEmail.value) {
            const user = await updateUserAffiliate(paypalEmail.value);
            updateUserState(user);
        }
    } finally {
        savingPaypalEmail.value = false;
    }
};

const onPasswordChanged = async () => {
    await logout();
    location.pathname = '/signin';
};

const updateUserState = (user: CustomilyUser) => {
    store.commit('user', user);
    emit('user-updated');
};
</script>

<style lang="scss" scoped>
.confirmation-message {
    display: flex;
    min-height: 200px;
}

.card-with-input {
    .card-body {
        max-width: 440px;
    }

    input {
        min-width: 400px;
    }
}
</style>
